var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{attrs:{"active":_vm.active,"scroll":_vm.scroll,"height":_vm.height,"installed":_vm.installed,"modal":_vm.modal,"dev":_vm.dev,"ready":_vm.ready}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }